// extracted by mini-css-extract-plugin
export default {"pageContainer":"PedidosEmPreparo_pageContainer__RZcw1","header":"PedidosEmPreparo_header__aVOPb","mainContent":"PedidosEmPreparo_mainContent__77koa"};